import React from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {setWizardPopupItem, setWizardPopupOpened, updateWizardList} from "../wizardActions";
import {wizardItemInterface} from "./wizardItemInterface";
import UiSwitch from "../../PageLayout/UiSwitch";
import {WIZARD_POPUP_TYPES} from "../wizardReducer";


const WizardItemActionButtons = (props) => {

  const {wizardItem, updateWizardList, setWizardPopupOpened, setWizardPopupItem} = props;

  const updateWizardItem = (property, newValue) => {
    wizardItem[property] = newValue;
    updateWizardList(wizardItem);
  }

  const wizardPhotoButtonClick = () => {
    setWizardPopupItem(wizardItem);
    setWizardPopupOpened(true, WIZARD_POPUP_TYPES.sceneSelection);
  }

  const wizardTogglesButtonClick = () => {
    setWizardPopupItem(wizardItem);
    setWizardPopupOpened(true, WIZARD_POPUP_TYPES.editItemToggles);
  }

  return (
    <div className="wizard-item__actions">
      <div className="wizard-item__actions-photo">
        <button className="ui-icon-photo" onClick={wizardPhotoButtonClick}/>
      </div>
      <div className="wizard-item__actions-photo">
        <button className="ui-icon-photo ui-icon-photo--toggle" onClick={wizardTogglesButtonClick}/>
      </div>
      <div className="wizard-item__actions-switch">
        <UiSwitch onClick={() => updateWizardItem("enabled", !wizardItem.enabled)}
                  textId={wizardItem.enabled ? "checkbox.enabled" : "checkbox.disabled"}
                  checked={wizardItem.enabled}/>
      </div>
    </div>
  )
};

WizardItemActionButtons.propTypes = {
  wizardItem: PropTypes.shape(wizardItemInterface).isRequired
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  updateWizardList,
  setWizardPopupOpened,
  setWizardPopupItem,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardItemActionButtons)
);
